// extracted by mini-css-extract-plugin
export var innerBlock = "song-module--inner-block--8c2a1";
export var item1 = "song-module--item-1--3e1b9";
export var item2 = "song-module--item-2--7246a";
export var item3 = "song-module--item-3--56046";
export var item4 = "song-module--item-4--75ecc";
export var song = "song-module--song--72b58";